import React, { Component } from 'react'
import styled from 'styled-components'
import config from '../../../data/SiteConfig'

class Logo extends Component {
  render() {
    return (
      <LogoContainer>
        <img id="nav-logo" src={config.siteLogo} alt="logo" />
      </LogoContainer>
    )
  }
}

export default Logo


const LogoContainer = styled.span`
  img {
    transition: all 400ms ease;
    max-height: 200px;
    max-width: 200px;  
  }
`



// WEBPACK FOOTER //
// ./src/components/Accessories/Logo.jsx